import { Checkbox, Stack } from "@mantine/core";
import FilterLayout from "./FilterLayout";

interface Props {
  filterName: string;
  value?: boolean;
  onChange: (value?: boolean) => void;
}

const Boolean = ({ filterName, onChange, value }: Props) => {
  return (
    <FilterLayout filterName={filterName}>
      <Stack gap="xs">
        <Checkbox
          label="True"
          checked={value == null || value}
          onChange={event => {
            if (event.currentTarget.checked && value == null) onChange(true);
            if (event.currentTarget.checked && value === false) onChange();

            if (!event.currentTarget.checked && value == null) onChange(false);
          }}
        />
        <Checkbox
          label="False"
          checked={!value}
          onChange={event => {
            if (event.currentTarget.checked && value == null) onChange(false);
            if (event.currentTarget.checked && value === true) onChange();

            if (!event.currentTarget.checked && value == null) onChange(true);
          }}
        />
      </Stack>
    </FilterLayout>
  );
};

export default Boolean;
